import { useEffect } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';

import { trackEvent } from '../utils';

export function useTrackImpression(
  /**
   * Optional name for the analytics impression event (e.g. 'matches_coupon_impressions'). Required to activate impression tracking.
   */
  eventName?: string,
  /**
   * Optional data for the impression event payload.
   */
  eventData?: Record<string, unknown>,
  /**
   * An optional reference to a data layer for analytics (e.g. window.dataLayer) to push events to.
   */
  dataLayer?: unknown[] | undefined,
) {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.5,
  });

  useEffect(() => {
    if (eventName && isIntersecting) {
      trackEvent(eventName, eventData, dataLayer);
    }
  }, [dataLayer, eventData, eventName, isIntersecting]);

  return ref;
}
